import { createAction, props } from '@ngrx/store';
import { MenuType } from '../../../models/menuType.enum';

export const setCurrentSelectedDate = createAction(
  '[UI] Set Current Selected Date',
  props<{ date: Date }>()
);

export const clearCurrentSelectedDate = createAction(
  '[UI] Clear Current Selected Date'
);

export const setCurrentLocationId = createAction(
  '[UI] Set Current Location Id',
  props<{ locationId: number }>()
);

export const clearCurrentLocationId = createAction(
  '[UI] Clear Current Location Id'
);

export const setCurrentMealId = createAction(
  '[UI] Set Current Meal Id',
  props<{ mealId: number }>()
);

export const clearCurrentMealId = createAction('[UI] Clear Current Meal Id');

export const setCurrentMenuType = createAction(
  '[UI] Set Current Menu Type',
  props<{ menuType: MenuType }>()
);

export const clearCurrentMenuType = createAction(
  '[UI] Clear Current Menu Type'
);

export const setCurrentLogoSrc = createAction(
  '[UI] Set Current Logo Src',
  props<{ logoSrc: string }>()
);

export const setPrimaryDishColor = createAction(
  '[UI] Set Primary Dish Color',
  props<{ color: string }>()
);

export const setAccentDishColor = createAction(
  '[UI] Set Accent Dish Color',
  props<{ color: string }>()
);
